import React, { useState } from 'react';
import VizSensor from 'react-visibility-sensor';

import Video from '../Video';
import Image from '../Image';
import Measurements from '../Measurements';
import Summary from '../Summary';

const Row = ({ blocks }) => {
  const [state, setState] = useState({});

  return (
    <VizSensor
      partialVisibility
      onChange={(isVisible) => {
        setState({ scrolledInView: isVisible });
      }}
    >
      <div className={`row u-max-height is-visible--${state.scrolledInView}`}>
        {blocks.map((block) => {
          const { key, type, className, ...restProps } = block;

          switch (type) {
            case 'video':
              return (
                <Video key={key} className={className} {...restProps} />
              );
            case 'image':
              return (
                <Image key={key} className={className} {...restProps} />
              );
            case 'measurements':
              return (
                <Measurements key={key} className={className} animate={state.scrolledInView} {...restProps} />
              );
            case 'summary':
              return (
                <Summary key={key} className={className} animate={state.scrolledInView} {...restProps} />
              );
            case 'row':
              return (
                <div className={className}>
                  <Row key={key} {...restProps} />
                </div>
              );
            default:
              // What should we do here?
          }
        })}
      </div>
    </VizSensor>
  );
};

export default Row;
